export const API_URL = `https://forkify-api.herokuapp.com/api/v2/recipes/`;
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '9c8251c7-1b17-4f04-bb57-72973aae4475';
export const MODAL_CLOSE_SEC = 2.5;
